export enum EmailResendModule {
  FacilityUsers,
  GroupAdmins,
  BizBoxUsers,
  Clients,
  Facilities,
}